import {
  onSelectParcel,
  resetSelectedParcels,
} from '../../../reducers/ui/routeDetail/selectedParcels';
import { getSelectedParcelsCount } from '../../../selectors/ui/routeDetail';
import { toggleSelectedStop } from './stopFilters';

// TODO: Remove this when the reducer is implemented
export const handleParcelSelect = (row) => (dispatch) =>
  dispatch(onSelectParcel(row));

export const handleParcelRowClick =
  ({ event, index, rowData }) =>
  (dispatch, getState) => {
    const selectedCount = getSelectedParcelsCount(getState());
    dispatch(toggleSelectedStop(rowData, index, event.shiftKey));
    selectedCount && dispatch(resetSelectedParcels());
  };
